import { ChangeDetectionStrategy, Component, inject, input, OnInit, OnDestroy, output, signal, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
   selector: 'app-otp-verification',
   templateUrl: './otp-verification.component.html',
   styleUrls: ['./otp-verification.component.scss'],
   imports: [NgOtpInputModule],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
   private platformId = inject(PLATFORM_ID);
   private isBrowser = isPlatformBrowser(this.platformId);

   // Displays dynamic title and text instructions based on context
   isInsidePopup = input<boolean>(false);
   verifyType = input<'email' | 'phone'>('email');
   identifierText = input<string>('name@example.com');
   isLoading = input<boolean>(false);
   isResending = input<boolean>(false);
   verify = output<string>();
   goBack = output<void>();
   resend = output<void>();
   editIdentifier = output<void>();
   errorMessage = input<string>('');

   otpValue: string | null = '';
   countdown = signal(60);
   canResend = signal(false);
   private timerInterval: any;

   otpConfig = {
      length: 4,
      allowNumbersOnly: true,
      containerClass: '!tw-flex !tw-w-full !tw-max-w-72 !tw-justify-between',
      inputClass: '!tw-flex !tw-w-full !tw-h-14 lg:!tw-h-16 !tw-font-medium !tw-text-xl lg:!tw-text-2xl !tw-ms-0 [&:not(:last-child)]:!tw-me-2 lg:[&:not(:last-child)]:!tw-me-3 !tw-rounded-base !tw-outline-brand-green'
   };

   ngOnInit() {
      this.startTimer();
   }

   ngOnDestroy() {
      this.stopTimer();
   }

   // Public method to be called by parent after successful API 
   public startTimer() {
      if (!this.isBrowser) return;
      
      this.countdown.set(60);
      this.canResend.set(false);
      this.stopTimer();
      
      this.timerInterval = setInterval(() => {
         this.countdown.update(val => {
            if (val <= 1) {
               this.stopTimer();
               this.canResend.set(true);
               return 0;
            }
            return val - 1;
         });
      }, 1000);
   }

   private stopTimer() {
      if (this.timerInterval) {
         clearInterval(this.timerInterval);
      }
   }

   formatTime(seconds: number): string {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
   }

   onOtpChange(otp: string) {
      this.otpValue = otp || '';
   }

   onVerify() {
      this.verify.emit(this.otpValue || '');
   }

   onResend() {
      if (this.canResend() && !this.isResending()) {
         this.resend.emit();
      }
   }

   onEditIdentifier() {
      this.editIdentifier.emit();
   }

   onGoBack() {
      this.goBack.emit();
   }
}
